type selectName = 'city' | 'specialization'
export async function getOptions (selectName: selectName, token: string){

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    // @ts-ignore
    return  await fetch(`https://ams-unity-group.ru/api/v2/general/search?type=${selectName}`, requestOptions).then(res => res.json()).then(res => res.data)
}